import { isSupportedWeek, isSupportedYear } from '@shared/helpers';
import { useAppSelector } from 'app/hooks';
import { getSelectedWeek, getSelectedYear } from 'app/slices/GamesSlice';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

export const StandingsIndexRoute: React.FC = () => {
  const selectedWeek = useAppSelector(getSelectedWeek);
  const selectedYear = useAppSelector(getSelectedYear);
  const navigate = useNavigate();
  // const { canShowStandings } = useSeasonStandings();

  useEffect(() => {
    console.log(`StandingsIndexRoute useEffect - selectedYear ${selectedYear} selectedWeek ${selectedWeek}`);
    if (isSupportedWeek(selectedWeek) && isSupportedYear(selectedYear)) {
      const pathURL = `${AppRoutes.Standings}/${selectedYear}/${selectedWeek.toLowerCase()}`;
      console.log(`StandingsIndexRoute useEffect - selectedYear ${selectedYear} selectedWeek ${selectedWeek}`);
      navigate(pathURL);
    }
  }, [selectedWeek, selectedYear]);

  return <></>;
};

export default StandingsIndexRoute;
